import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-development-resources',
  templateUrl: './development-resources.component.html',
  styleUrls: ['./development-resources.component.sass']
})
export class DevelopmentResourcesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
